import { render, staticRenderFns } from "./AppSearchReservationItem.vue?vue&type=template&id=3288c2d4&scoped=true&"
import script from "./AppSearchReservationItem.vue?vue&type=script&lang=js&"
export * from "./AppSearchReservationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288c2d4",
  null
  
)

export default component.exports